import home from "../../assets/images/home.jpg";
import homeVideo from "../../assets/videos/home.mp4";
import "./welcome.css";
import { useEffect, useRef, useState } from "react";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import AboutUsComponent from "./about.component";
import LoginComponent from "./login.component";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import { getEventNoticeList, getEventFilePreview, giveEventFilePreview } from "../../services/event.service";
import DrivePdf from "../../assets/documents/SMART_Membership_Drive.pdf";

const imagesForJoinSmart = [
  require("../../assets/images/joinSmart1.png"),
  require("../../assets/images/joinSmart4.png"),
  require("../../assets/images/joinSmart3.png"),
  require("../../assets/images/joinSmart5.png"),
];

const WelcomeComponent = () => {

  const [currentJoinUsImage, setCurrentJoinUsImage] = useState(0);
  const [eventNoticeList, setEventNoticeList] = useState([]);
  const [membershipDriveNotice, setMembershipDriveNotice] = useState(null);

  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5; // Slow down to 50% speed
    }
  }, []);

  const normalizeDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const fetchEventNotices = async () => {
    try {
      const activeEventNoticeList = await getEventNoticeList();
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const filteredNotices = activeEventNoticeList.filter(eventNotice => {
        const startDate = normalizeDate(eventNotice.startDate);
        const endDate = normalizeDate(eventNotice.endDate);
        // Notice should be visible if today is between start and end dates (inclusive)
        return today >= startDate && today <= endDate;
      });

      setEventNoticeList(filteredNotices || []);
      // Find and set membership drive notice
      const driveNotice = filteredNotices.find(notice =>
        notice.message.includes("Membership Drive 2025")
      );
      setMembershipDriveNotice(driveNotice || null);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const handleFilePreview = async (eventFileName) => {
    try {
      const previewData = await getEventFilePreview(eventFileName);
      const EXT = eventFileName.split('.').pop();
      giveEventFilePreview(EXT, previewData, eventFileName);
    } catch (error) {
      console.error("Error fetching preview data:", error);
    }
  };

  useEffect(() => {
    fetchEventNotices();
    const interval = setInterval(() => {
      setCurrentJoinUsImage((prev) => (prev + 1) % imagesForJoinSmart.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [imagesForJoinSmart.length]);



  return (
    <div className="smart-wrapper">
      <Helmet>
        <title>SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>


      <HeaderComponent />
      <NavbarComponent />


      <section id="fixed-sub-nav" className="fade-in main-wrapper">
        <div className="blog-section text-center text-light">
          <video
           ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            className="position-absolute w-100 h-100"
            style={{
              objectFit: 'cover',
              top: 0,
              left: 0,
              zIndex: -1,
            }}
          >
            <source src={homeVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="container-fluid">
            <h1 className="pt-5">Welcome to SMART</h1>
            <p className="welcome-header" style={{ fontSize: '20px', marginTop: '15px', textAlign: 'center' }}>
              Join us as we explore cutting-edge microwave,
              antenna, and radar advancements. Our community of experts is
              dedicated to fostering innovation, education, and collaboration.
            </p>
          </div>
          <div className="registration-closed">
            SMART 2025 Registration is Closed
          </div>
        </div>
       <div className="scroll-container bg-danger py-3 text-white overflow-hidden">
            <span className="scrolling-text">&nbsp;&nbsp;&nbsp;&nbsp; Disclaimer: The views,opinions and statements expressed by the speakers during this symposium are their own and do not reflect those of the organizers, sponsors, or affiliated institutions and SMART. 
            Any consequences further to such statements shall be handled by respective individuals. Any trademarks, pictures, images used are from open sources and are with due permission only. 
            All these belong to respective owners and are with their copyrights.</span>
       </div>
        {/* Events Section */}
        <div id="events" className="py-2 fade-in">
          <div className="container">
            <div className="row">
              {/* Events Column */}

              <div className="col-lg-6 mb-2 mt-4 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="200">
                <h3 style={{ textAlign: 'left' }}>Society for Microwaves, Antennas and Radar Technologies</h3>
                <p style={{ textAlign: 'justify', fontSize: '20px', marginTop: '15px' }}>
                  Society for Microwaves, Antennas and Radar Technologies(SMART) promotes the general advancement of educational, training and engineering
                  aspects of Microwaves, Antennas, Radar Technologies, their allied subjects, and their applications.
                  <br /><br />
                  SMART may facilitate the exchange of information and ideas on these subjects amongst the members of the Society. Further
                  to this, it has been advised to undertake other activities that will further the objectives and aims of the
                  Society and promote advancement in Microwaves, Antennas, and Radar Technologies and their allied subjects.
                </p>
              </div>

              {/* About SMART Column */}
              <div className="col-lg-6 mb-2 mt-4 order-1 order-lg-2" data-aos="fade-up" data-aos-delay="100">
                <div className="card border border-primary">
                  <div className="event-notice-widget-heading" data-element_type="widget" data-widget_type="heading.default">
                    <div className="event-notice-widget-container">
                      <h2 className="event-notice-heading-title">Announcements</h2>
                    </div>
                  </div>
                  <div className="elementor-widget-html" data-element_type="widget" data-widget_type="html.default">
                    <div className="event-notice-widget-container">
                      <div className="event-marquee-container">
                        <div className="event-marquee-wrapper">
                          <div className="event-marquee-content">
                            <ul>
                              {eventNoticeList.length > 0 ? (
                                eventNoticeList.map((eventNotice, index) => (
                                  <li key={index}>
                                    <h5 className="event-title" style={{ whiteSpace: 'pre-line' }}>
                                      {eventNotice.message}
                                      <br />
                                      {eventNotice.attachment && (
                                        <span
                                          onClick={() => handleFilePreview(eventNotice.attachment)}
                                          style={{
                                            backgroundColor: 'rgb(177 237 255)',
                                            color: 'rgb(21 14 188)',
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            display: 'inline-block',
                                            marginTop: '8px',
                                          }}
                                        >
                                          {eventNotice.attachment}
                                        </span>
                                      )}
                                    </h5>
                                    <br />
                                  </li>
                                ))
                              ) : (
                                <div style={{ padding: '15px', textAlign: 'center', height: '200px' }}>
                                  No active event notices at this time.
                                </div>
                              )}
                            </ul>
                          </div>
                          {/* Duplicate the content to create a seamless loop effect */}
                          <div className="event-marquee-content">
                            <ul>
                              {eventNoticeList.length > 0 ? (
                                eventNoticeList.map((eventNotice, index) => (
                                  <li key={index}>
                                    <h5 className="event-title" style={{ whiteSpace: 'pre-line' }}>
                                      {eventNotice.message}
                                      <br />
                                      {eventNotice.attachment && (
                                        <span
                                          onClick={() => handleFilePreview(eventNotice.attachment)}
                                          style={{
                                            backgroundColor: 'rgb(177 237 255)',
                                            color: 'rgb(21 14 188)',
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            cursor: 'pointer',
                                            display: 'inline-block',
                                            marginTop: '8px',
                                          }}
                                        >
                                          {eventNotice.attachment}
                                        </span>
                                      )}
                                    </h5>
                                    <br />
                                  </li>
                                ))
                              ) : (
                                <div style={{ padding: '15px', textAlign: 'center', height: '200px' }}>
                                  No active event notices at this time.
                                </div>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-12">
                    <div
                      className="membership-drive-notice download-cta"
                      role="button"
                      tabIndex={0}
                      onClick={() => window.open(DrivePdf, "_blank")}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          window.open(DrivePdf, "_blank");
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "7px",
                        textAlign: "center",
                      }}
                    >
                      <h4>SMART – Membership Drive 2025 (Now Open)</h4>
                      <p className="mb-1">Click to view the PDF</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
      <section id="about" className="py-5 fade-in">
        <AboutUsComponent />
      </section>
      <hr />
      <section id="login" className="py-5">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-md-6 mt-3" style={{ marginBottom: 'auto' }}>
              <h3 className="about-title">Log In to Your SMART Account</h3>
              <div className="banner-overlay"></div>
              <div className="column-height image-block banner-image-content banner-bg-image mt-4">
                <img
                  src={imagesForJoinSmart[currentJoinUsImage]}
                  alt="banner"
                  className="banner-img-responsive"
                />
              </div>

              <div className="clearfix"></div>
              <p className="about-details mt-4" style={{ fontSize: '20px' }}>
                As a professional in the fields of microwaves, antennas, and radar technologies, logging into the Society for Microwaves, Antennas and Radar Technologies (SMART) platform provides you with exclusive access to a wealth of resources and opportunities. By becoming a member, you can participate in specialized workshops, receive newsletters, and connect with a network of experts in areas such as RF and microwave engineering, millimeter-wave and terahertz technologies, and radar systems. Engaging with SMART will enhance your professional development and keep you informed about the latest advancements in your field.
              </p>
            </div>
            <div className="col-md-6" style={{ marginTop: '30px' }}>
              <LoginComponent />
            </div>

          </div>
        </div>

      </section>


      <FooterComponent />

    </div>
  )
}
export default WelcomeComponent;